module.exports = __webpack_public_path__ + "img/refresh.d44e3e26.svg";